import { Box, Modal, Breadcrumbs, Chip } from "@mui/material";
import { QuickSearchModalStyle } from "#next/components/modals/styles";
import { emphasize, styled } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
import ImageIcon from "@mui/icons-material/Image";
import ShortTextIcon from "@mui/icons-material/ShortText";
import { TextSearch } from "#next/components/quick-search/interface/TextSearch";
import { MediaSearch } from "#next/components/quick-search/interface/MediaSearch";
import { UserSearch } from "#next/components/quick-search/interface/UserSearch";
import { useState } from "react";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor = theme.palette.background.paper;
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    cursor: "pointer",
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip; // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

export const QuickSearchModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [searchSelection, setSearchSelection] = useState("text"); // this should be typed better

  const SearchSelection = () => {
    if (searchSelection === "user") return <UserSearch />;
    else if (searchSelection === "media")
      return <MediaSearch closeQuickSearchModal={onClose} />;
    else return <TextSearch closeQuickSearchModal={onClose} />;
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={QuickSearchModalStyle}>
        <Box justifyContent="center" display="flex">
          <Breadcrumbs aria-label="breadcrumb">
            <StyledBreadcrumb
              component="a"
              label="Text"
              icon={<ShortTextIcon fontSize="small" />}
              onClick={() => setSearchSelection("text")}
            />
            <StyledBreadcrumb
              component="a"
              label="User"
              icon={<PersonIcon fontSize="small" />}
              onClick={() => setSearchSelection("user")}
            />
            <StyledBreadcrumb
              component="a"
              label="Media"
              icon={<ImageIcon fontSize="small" />}
              onClick={() => setSearchSelection("media")}
            />
          </Breadcrumbs>
        </Box>
        <Box>
          <SearchSelection />
        </Box>
      </Box>
    </Modal>
  );
};
